import Log from '@/classes/debug/Log'
import issueApi from '@/api/issue/issueApi'
import AuthUser from '@/classes/auth/AuthUser'
import Issue from '@/classes/case/Issue'

const state = {
  issues: []
}

const mutations = {
  setStateIssues: (state, data) => {
    state.issues = Issue.asIssues(data)
  },
  removeIssue: (state, issue) => {
    state.issues = state.issues.filter(item => {
      return item.id !== issue.id
    })
  }
}

const actions = {
  getIssues ({ commit }) {
    return issueApi.getIssues().then((response) => {
      commit('setStateIssues', response.data)
      return true
    }).catch((err) => {
      throw err
    })
  },
  updateIssueForm ({ commit }, requestData) {
    return issueApi.patchIssue(requestData.data.id, requestData.serializedData).then((response) => {
      Log.debug('Patched Form Data for Issue Form ' + requestData.serializedData + ' as ' + AuthUser.getProfileTypeVerbose())
      return response
    }).catch((err) => {
      throw err
    })
  },
  updateIssueReviewComment ({ commit }, requestData) {
    let payload = { text: requestData.comment }
    return issueApi.patchIssueReviewComment(requestData.id, payload).then((response) => {
      Log.debug('Posted Comment Data for Issue Form ' + requestData.serializedData + ' as ' + AuthUser.getProfileTypeVerbose())
      return response
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
